export default __webpack_public_path__ + "static/media/edit.76cdf928.svg";